// import { useNotificationsWebSocket } from '@/legacy/hooks/useNotificationsWebSocket';
import { useNotifications } from '@/legacy/hooks/useNotifications';
import NotificationItem from '@/legacy/features/notifications/components/NotificationItem';
import Offcanvas from '@/legacy/components/ui/OffCanvas';
import imageSrc from '@/legacy/assets/img/logos/frekuent_iso_purple.svg';
import { useTranslation } from 'react-i18next';
import { Notification } from '@/legacy/store/zustand/slices/notificationSlice';
import { useNavigate } from 'react-router';
import { useStore } from '@/legacy/store/zustand';
import { MODAL_TYPES } from '@/legacy/constants/modalTypes';
import { Button } from '@frekuent/orbit/components';
import { TrashIcon } from '@frekuent/orbit/icons';
import { Tooltip } from 'react-tooltip';

type NotificationsOffcanvasProps = {
	userId: number | string;
};

const NotificationsOffcanvas = ({ userId }: NotificationsOffcanvasProps) => {
	const { notifications } = useNotifications();
	// COMMENTED OUT beacuse backend notifications are not working now
	// const { markNotificationsAsRead } = useNotificationsWebSocket(userId);
	// Console.log to avoid unused variable warning
	const { t } = useTranslation();
	const navigate = useNavigate();
	const openModal = useStore((s) => s.openModal);
	const { clearAllRead, closeOffcanvas } = useStore();

	const handleNotificationClick = (notification: Notification) => {
		if (notification.url) {
			navigate(notification.url);
			closeOffcanvas();
		} else if (notification.modalData) {
			openModal(MODAL_TYPES.NOTIFICATION_MODAL, {
				...notification.modalData,
			});
			closeOffcanvas();
		}
	};

	return (
		<Offcanvas
			id='notifications'
			otherActions={
				<>
					<Button
						type='button'
						onClick={clearAllRead}
						size='icon'
						className='text-icon-cuaternary'
						data-tooltip-id='delete-all-notifications'
						data-tooltip-content={t('notifications.delete_all_read')}
					>
						<TrashIcon />
					</Button>
					<Tooltip id='delete-all-notifications' />
				</>
			}
		>
			<h2 className='text-primary text-3xl font-medium first-letter:capitalize'>
				{t('notifications.title')}
			</h2>

			{notifications.length === 0 ? (
				<p className='text-xl font-bold'>{t('notifications.no_notifications')}</p>
			) : (
				<ul className='flex flex-col gap-3'>
					{notifications.map((notification) => (
						<li key={notification.id}>
							<NotificationItem
								id={notification.id}
								imageSrc={imageSrc}
								title={notification.title}
								subtitle={notification.body}
								time={new Date(notification.created_at).toLocaleTimeString()}
								read={notification.readed}
								onClick={() => {
									// markNotificationsAsRead(notification.id);
									handleNotificationClick(notification);
								}}
							/>
						</li>
					))}
				</ul>
			)}
		</Offcanvas>
	);
};

export default NotificationsOffcanvas;
